<template>
  <v-container fill-height fluid pa-0>
    <v-row justify="center" no-gutters>
      <transition name="fade" mode="out-in">
        <!--  <v-col cols="6" v-if="!hasCompletedInitialSelected && languages && languages.length > 1">
            <page-heading :text="$t('views.languageselect.complete_english')" text-center></page-heading>
            <div class="body-1 text-center mb-5 mt-5">
              {{$t('views.languageselect.complete_english_description')}}
            </div>
            <v-row justify="center">
              <v-col cols="auto">
                <v-btn :loading="loading"
                       @click="changeLanguage()"
                       color="secondary"
                       height="48"
                       small
                >{{$t('general.continue')}}
                </v-btn>
              </v-col>

            </v-row>
            <v-row justify="center">
              <v-col cols="auto">
                <v-btn
                    @click="hasCompletedInitialSelected=true"
                    color="white"
                    height="48"
                    small
                    text
                >{{$t('views.languageselect.no_english')}}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" v-else>-->
        <v-col cols="6">
          <page-heading :text="$t('views.languageselect.title')" text-center></page-heading>
          <div class="body-1 text-center mb-5 mt-5">
            {{$t('views.languageselect.description')}}
          </div>
          <v-row justify="center">
            <v-col cols="auto">
              <v-select :items="languages"
                        :label="$t('views.languageselect.preferred_language')"
                        item-text="languagename"
                        item-value="languageid"
                        light
                        solo
                        v-model="locale"
              ></v-select>
            </v-col>
            <v-col cols="auto">
              <v-btn :loading="loading"
                     @click="changeLanguage()"
                     color="secondary"
                     height="48"
              >{{$t('general.continue')}}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </transition>
    </v-row>
  </v-container>
</template>

<script>
import PageHeading from "../../components/framework/PageHeading";
import navigateToAssessmentState from "../../router/assessmentstate";

export default {
  components: {
    PageHeading
  },
  props: {
    nextRoute: {
      type: Object
    }
  },
  name: "PreferredLanguage",
  data: () => ({
    locale: null,
    loading: false,
    hasCompletedInitialSelected : false
  }),
  computed: {
    languages() {
      return this.$store.state.assessment.assessment.project.available_languages;// || this.$store.state.journey.journey.languages;
    }
  },
  created() {
    this.locale = this.$store.state.assessment.assessment.project.default_languageid || this.$store.state.language.locale;
  },
  methods: {
    changeLanguage() {
      this.loading = true;
      this.$store.dispatch('assessment/updateAssessmentLanguage', this.locale).then(() => {
        this.navigate();
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    navigate() {
      if (this.nextRoute) {
        this.$router.replace(this.nextRoute);
      } else {
        navigateToAssessmentState((route) => {
          this.$router.replace(route);
        });
      }
    }
  }
}
</script>

<style scoped>

</style>
